// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P2I_","colBig":"styles_colBig__1vc3p","colSmall":"styles_colSmall__1EkRR","shopifyNameWrapper":"styles_shopifyNameWrapper__1Mop1"};